import {useNavigate, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../../helper/api";
import SearchBox from "../../../components/SearchBox";
import Layout from "../../../components/Layout";
import Pagination from "../../../components/Pagination";
import AlertStockFilterTab from "../../../components/Product/AlertStock/AlertStockFilterTab";
import AlertStockTable from "../../../components/Tables/AlertStockTable";
import AlertStockFilterBox from "../../../components/AlertStock/AlertStockFilterBox";

function AlertStock() {
    const location = useLocation();
    const navigate = useNavigate();
    const search = window.location.search;
    const params = new URLSearchParams(search);

    const [isLoading, setIsLoading] = useState(true);
    const [updateData, setUpdateData] = useState('0');
    const [pageNumber, setPageNumber] = useState(parseInt(params.get('page') || '1'));
    const [data, setData] = useState({});
    const [searchQuery, setSearchQuery] = useState({
        term: params.get('term') || '',
        by: params.get('by') || 'title'
    });
    const [filterQuery, setFilterQuery] = useState(() => {
        try {
            return params.get('filters') ? JSON.parse(decodeURIComponent(params.get('filters'))) : {
                status: 'unread'
            };
        } catch (e) {
            return {
                status: 'unread'
            };
        }
    });

    // state tab for filtering
    const [statsTab, setStatsTab] = useState(null);
    const [selectedStatsTab, setSelectedStatsTab] = useState(params.get('status') || '');

    // ذخیره وضعیت فیلترها در URL
    useEffect(() => {
        const currentParams = new URLSearchParams(location.search);
        
        // ذخیره فیلترها در URL
        if (Object.keys(filterQuery).length > 0) {
            currentParams.set('filters', encodeURIComponent(JSON.stringify(filterQuery)));
        } else {
            currentParams.delete('filters');
        }
        
        // ذخیره جستجو در URL
        if (searchQuery.term) {
            currentParams.set('term', searchQuery.term);
            currentParams.set('by', searchQuery.by);
        } else {
            currentParams.delete('term');
            currentParams.delete('by');
        }
        
        // ذخیره شماره صفحه در URL
        currentParams.set('page', pageNumber.toString());
        
        // ذخیره وضعیت تب در URL
        if (selectedStatsTab) {
            currentParams.set('status', selectedStatsTab);
        } else {
            currentParams.delete('status');
        }
        
        // به‌روزرسانی URL بدون ریفرش صفحه
        navigate('?' + currentParams.toString(), { replace: true });
    }, [filterQuery, searchQuery, pageNumber, selectedStatsTab]);

    //fetch data from server and update data based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const res = await ApiRoute.stock.alert.index.fn({
                shop_id: shopId(),
                page: pageNumber
            }, filterQuery);
            setData(res);
            setIsLoading(false);
        })();
    }, [updateData]);

    const paginationData = data?.results;
    const tableData = data?.results?.data ?? [];

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString());
    }, [pageNumber]);

    // watch searchQuery and update updateData state
    useEffect(() => {
        const newFilterQuery = { ...filterQuery };
        newFilterQuery.quick_search = searchQuery;
        setFilterQuery(newFilterQuery);
        setPageNumber(1);
        setUpdateData(Date.now().toString());
    }, [searchQuery]);

    useEffect(() => {
        setUpdateData(Date.now().toString());
    }, [filterQuery]);

    const filters1 = [
        {
            title: 'عادی',
            quantity: 1000,
            active: true
        }, {
            title: 'پیش سفارش',
            quantity: 100
        },
    ]
    const filters2 = [
        {
            title: 'خوانده شده',
            quantity: 1000,
            active: true
        },
        {
            title: 'خوانده نشده',
            quantity: 1000,
            active: false
        },
        {
            title: 'در انتظار',
            quantity: 1000,
            active: false
        },
    ]

    return (
        <Layout>
            <div>
                <div className="page-title mb-3"><span className="inline-block bg-white pl-3">اطلاع رسانی موجودی کالا</span></div>
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <SearchBox SearchByOptions={[
                            {
                                label: "نام محصول",
                                value: "product_title"
                            },
                            {
                                label: "نام دسته بندی",
                                value: "categpry_title"
                            },
                            {
                                label: "نام برند",
                                value: "brand_title"
                            }
                        ]} SearchByDefault={`product_title`} SetSearchQuery={setSearchQuery} SearchIn={true} />
                    </div>
                </div>

                <AlertStockFilterBox setFilterQuery={setFilterQuery} initialFilter={filterQuery} />

                <div className="main-content p-1 mt-3">
                    {data?.meta_data?.stats && <AlertStockFilterTab selectedTab={selectedStatsTab} setSelectedTab={(s) => {
                        const newFilterQuery = { ...filterQuery };
                        if (s === "default") {
                            newFilterQuery.is_preorder = false;
                        } else if (s === "preorder") {
                            newFilterQuery.is_preorder = true;
                        } else {
                            delete newFilterQuery.is_preorder;
                        }
                        setFilterQuery(newFilterQuery);
                        setUpdateData(Date.now().toString());
                    }} options={data.meta_data.stats} />}

                    {isLoading ? (
                        <div className="flex justify-center items-center py-10">
                            <div className="x2-loader"></div>
                        </div>
                    ) : (
                        <>
                            {data && <AlertStockTable setUpdateData={setUpdateData} tableData={tableData} />}
                            {data && <Pagination Data={paginationData} SetPageNumber={setPageNumber} />}
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default AlertStock;